import { useMutation, useQuery } from 'react-query'
import { apiPostVehicleTest } from '../api/vehicletests-api'
import { getVehicleTestById } from '../api/vehicle-tests-api'

export const useAddVehicleTest = () => {
  return useMutation(({ payload, authToken }) =>
    apiPostVehicleTest({ payload, authToken }),
  )
}

// Fetches a single vehicle test by id -- used to resolve a vehicle test from
// a route param when it wasn't handed down via router location.state (e.g.
// after a page refresh or a shared link).
export const useVehicleTestById = (vehicleTestId) => {
  const {
    status,
    data: vehicleTest,
    error,
    isLoading,
  } = useQuery(
    ['vehicle-test-by-id', vehicleTestId],
    async () => {
      return await getVehicleTestById(vehicleTestId)
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!vehicleTestId,
    },
  )
  return { status, vehicleTest, error, isLoading }
}
